"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsOnboardingContractSigned = exports.userAvatarSelector = exports.createAccountSelectors = exports.getAccountOwnerUuid = exports.getUserNameByAccessTokenUuid = exports.mapAccountUuidToName = exports.mapUuidToName = exports.userDetailsSelector = exports.userSelector = exports.makeGetUserFullNameByAccessTokenUuid = exports.selectSignedOnboardingContractsTypes = exports.selectSubAccountsGrantedToUser = exports.selectAccountsGrantedToUser = exports.selectUserAccessByUser = exports.selectProfileMeta = exports.selectHasMultipleUserExperiences = exports.selectPermissions = exports.selectContactUsRequest = exports.selectUserCreateDrawerVisible = exports.selectEngineUser = exports.selectDeactivateUsers = exports.selectUserAccessTokenByUuid = exports.selectUserAccessTokenById = exports.selectUserScopes = exports.selectUserFeatureFlags = exports.selectUserRoles = exports.selectAllUsersByUuid = exports.selectUsersByUuid = exports.selectUsersAccess = exports.selectUsers = exports.selectUserState = exports.UserAccountsStatus = void 0;
var difference_1 = __importDefault(require("lodash/difference"));
var memoize_1 = __importDefault(require("lodash/memoize"));
var reselect_1 = require("reselect");
var finance_client_1 = require("@evenfinancial/finance-client");
var access_control_1 = require("@portal/common/dist/access-control");
var selectors_1 = require("../account/selectors");
var selectors_2 = require("../subaccount/selectors");
var util_1 = require("./util");
var UserAccountsStatus;
(function (UserAccountsStatus) {
    UserAccountsStatus["All"] = "All";
    UserAccountsStatus["Empty"] = "n/a";
})(UserAccountsStatus = exports.UserAccountsStatus || (exports.UserAccountsStatus = {}));
var selectUserState = function (state) { return state.user; };
exports.selectUserState = selectUserState;
var selectUsers = function (state) { return state.user.rows; };
exports.selectUsers = selectUsers;
var selectUsersAccess = function (state) {
    return state.user.accessByUuid;
};
exports.selectUsersAccess = selectUsersAccess;
var selectUsersByUuid = function (state) {
    return state.user.rowsByUuid;
};
exports.selectUsersByUuid = selectUsersByUuid;
exports.selectAllUsersByUuid = (0, reselect_1.createSelector)([exports.selectUsers], function (users) {
    return users.reduce(function (accum, user) {
        accum[user.accountUuid] = user;
        return accum;
    }, {});
});
var selectUserRoles = function (state) { var _a, _b; return (_b = (_a = state.user.profileMeta) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : []; };
exports.selectUserRoles = selectUserRoles;
var selectUserFeatureFlags = function (state) { var _a; return (_a = state.user.profileMeta) === null || _a === void 0 ? void 0 : _a.featureFlags; };
exports.selectUserFeatureFlags = selectUserFeatureFlags;
var selectUserScopes = function (state) { var _a; return (_a = state.user.profileMeta) === null || _a === void 0 ? void 0 : _a.scopes; };
exports.selectUserScopes = selectUserScopes;
var selectUserAccessTokenById = function (state) {
    return state.user.accessTokenById;
};
exports.selectUserAccessTokenById = selectUserAccessTokenById;
var selectUserAccessTokenByUuid = function (state) {
    return state.user.accessTokenByUuid;
};
exports.selectUserAccessTokenByUuid = selectUserAccessTokenByUuid;
var selectDeactivateUsers = function (state) {
    return state.user.deactivationRows;
};
exports.selectDeactivateUsers = selectDeactivateUsers;
var selectEngineUser = function (state) { var _a, _b; return (_b = (_a = state.user) === null || _a === void 0 ? void 0 : _a.profileMeta) === null || _b === void 0 ? void 0 : _b.engineUser; };
exports.selectEngineUser = selectEngineUser;
var selectUserCreateDrawerVisible = function (state) {
    return state.user.createDrawerVisible;
};
exports.selectUserCreateDrawerVisible = selectUserCreateDrawerVisible;
var selectContactUsRequest = function (state) {
    return state.user.contactUsRequest;
};
exports.selectContactUsRequest = selectContactUsRequest;
var selectPermissions = function (state) {
    return state.user.permissions;
};
exports.selectPermissions = selectPermissions;
var selectHasMultipleUserExperiences = function (state) {
    return state.user.hasMultipleUserExperiences;
};
exports.selectHasMultipleUserExperiences = selectHasMultipleUserExperiences;
var selectProfileMeta = function (state) {
    return state.user.profileMeta;
};
exports.selectProfileMeta = selectProfileMeta;
var selectUserAccessByUser = function (state, userUuid) { var _a; return (_a = state.user.accessByUuid) === null || _a === void 0 ? void 0 : _a[userUuid]; };
exports.selectUserAccessByUser = selectUserAccessByUser;
exports.selectAccountsGrantedToUser = (0, reselect_1.createSelector)([exports.selectUserAccessByUser, selectors_1.selectAccountsKeyedByUuid], function (userAccess, accountsByUuid) { var _a, _b; return (_b = (_a = userAccess === null || userAccess === void 0 ? void 0 : userAccess.grants.accounts) === null || _a === void 0 ? void 0 : _a.map(function (uuid) { return accountsByUuid[uuid]; })) !== null && _b !== void 0 ? _b : []; });
exports.selectSubAccountsGrantedToUser = (0, reselect_1.createSelector)([exports.selectUserAccessByUser, selectors_2.selectAllSubAccountsKeyedByUuid], function (userAccess, subAccountsByUuid) { var _a, _b; return (_b = (_a = userAccess === null || userAccess === void 0 ? void 0 : userAccess.grants.subaccounts) === null || _a === void 0 ? void 0 : _a.map(function (uuid) { return subAccountsByUuid[uuid]; })) !== null && _b !== void 0 ? _b : []; });
var selectSignedOnboardingContractsTypes = function (state) {
    var _a = state.onboardingContract, contracts = _a.contracts, signedContracts = _a.signedContracts;
    return signedContracts.reduce(function (accum, _a) {
        var _b;
        var onboardingContractId = _a.onboardingContractId;
        var contractType = (_b = contracts.find(function (_a) {
            var id = _a.id;
            return onboardingContractId === id;
        })) === null || _b === void 0 ? void 0 : _b.type;
        if (contractType) {
            accum.push(contractType);
        }
        return accum;
    }, []);
};
exports.selectSignedOnboardingContractsTypes = selectSignedOnboardingContractsTypes;
var makeGetUserByAccessTokenUuid = function (state) {
    return (0, memoize_1.default)(function (accessTokenUuid) {
        var _a, _b, _c;
        if (accessTokenUuid === void 0) { accessTokenUuid = ''; }
        return (_c = (_b = (_a = (0, exports.selectUserAccessTokenByUuid)(state)) === null || _a === void 0 ? void 0 : _a[accessTokenUuid]) === null || _b === void 0 ? void 0 : _b.richAccount) === null || _c === void 0 ? void 0 : _c.user;
    });
};
var makeGetUserFullNameByAccessTokenUuid = function (state) {
    var getUserByAccessTokenUuid = makeGetUserByAccessTokenUuid(state);
    return (0, memoize_1.default)(function (accessTokenUuid) {
        if (accessTokenUuid === void 0) { accessTokenUuid = ''; }
        return (0, util_1.getUserFullName)(getUserByAccessTokenUuid(accessTokenUuid));
    });
};
exports.makeGetUserFullNameByAccessTokenUuid = makeGetUserFullNameByAccessTokenUuid;
var mapUserToUserRow = function (user, canSeeAllAccounts, accounts, accessByUuid, userDeactivation) {
    var _a, _b;
    if (!user) {
        return null;
    }
    var accountsUuids = ((_b = (_a = accessByUuid === null || accessByUuid === void 0 ? void 0 : accessByUuid[user.uuid]) === null || _a === void 0 ? void 0 : _a.grants) === null || _b === void 0 ? void 0 : _b.accounts) || [];
    var userType = (user === null || user === void 0 ? void 0 : user.roles) ? (0, access_control_1.getUserTypeRole)(user.roles) : '';
    var userAccounts;
    var accountsStatus;
    if (canSeeAllAccounts && accountsUuids.length === 0) {
        userAccounts = [{ name: 'All', uuid: '' }];
        accountsStatus = UserAccountsStatus.All;
    }
    else if (accountsUuids.length === 0) {
        userAccounts = [{ name: 'n/a', uuid: '' }];
        accountsStatus = UserAccountsStatus.Empty;
    }
    else {
        userAccounts = accountsUuids.map(function (uuid) {
            var userAccount = accounts === null || accounts === void 0 ? void 0 : accounts.find(function (account) { return account.uuid === uuid; });
            return { name: userAccount === null || userAccount === void 0 ? void 0 : userAccount.name, uuid: uuid };
        });
        accountsStatus =
            userAccounts[0].name || UserAccountsStatus.Empty;
    }
    return __assign(__assign({}, user), { accessRoles: (user === null || user === void 0 ? void 0 : user.roles) ? (0, access_control_1.getUserAccessRoles)(user.roles) : [], accounts: userAccounts, accountsStatus: accountsStatus, completeName: (0, util_1.getUserFullName)(user), deactivationId: userDeactivation === null || userDeactivation === void 0 ? void 0 : userDeactivation.id, isActive: !userDeactivation, isActiveDisplay: userDeactivation ? 'Inactive' : 'Active', partnerRoles: (user === null || user === void 0 ? void 0 : user.roles) ? (0, access_control_1.getUserPartnerRoles)(user.roles) : [], userType: userType });
};
exports.userSelector = (0, reselect_1.createSelector)([exports.selectUsers, exports.selectDeactivateUsers], function (users, userDeactivations) {
    return users.map(function (user) { return (__assign(__assign({}, user), { isActive: !userDeactivations.find(function (item) { return item.userId === user.id && !('deletedBy' in item); }) })); });
});
exports.userDetailsSelector = (0, reselect_1.createSelector)([
    function (_a, props) {
        var user = _a.user;
        return user.accessByUuid[props.uuid];
    },
    function (_a, _b) {
        var user = _a.user;
        var uuid = _b.uuid;
        return user.byUuid[uuid];
    },
    exports.selectDeactivateUsers,
    exports.selectPermissions,
], function (access, user, deactivateUsers, _a) {
    var canSeeAllAccounts = _a.canSeeAllAccounts;
    var deactivateUser = user &&
        deactivateUsers.find(function (item) { return item.userId === user.id && !('deletedBy' in item); });
    var isActive = !deactivateUser;
    return {
        access: access,
        deactivationIds: deactivateUser === null || deactivateUser === void 0 ? void 0 : deactivateUser.id,
        isActive: isActive || false,
        user: mapUserToUserRow(user, canSeeAllAccounts),
    };
});
var mapUuidToName = function (uuid, users) {
    var userRecord = users.find(function (u) { return u.uuid === uuid; });
    return (0, util_1.getUserFullName)(userRecord);
};
exports.mapUuidToName = mapUuidToName;
var mapAccountUuidToName = function (users, accountUuid) {
    var userRecord = users.find(function (u) { return u.accountUuid === accountUuid; });
    return (0, util_1.getUserFullName)(userRecord);
};
exports.mapAccountUuidToName = mapAccountUuidToName;
var getUserNameByAccessTokenUuid = function (user, uuid) {
    var richToken = user.accessTokenByUuid[uuid];
    var userRecord = richToken === null || richToken === void 0 ? void 0 : richToken.richAccount.user;
    return (0, util_1.getUserFullName)(userRecord);
};
exports.getUserNameByAccessTokenUuid = getUserNameByAccessTokenUuid;
var getAccountOwnerUuid = function (accounts, subAccount, role) {
    if (subAccount.subAccountOwners && subAccount.subAccountOwners[role]) {
        return subAccount.subAccountOwners[role];
    }
    var account = accounts.find(function (a) { return a.uuid === subAccount.accountUuid; });
    return (account === null || account === void 0 ? void 0 : account.accountOwners)
        ? account.accountOwners[role]
        : undefined;
};
exports.getAccountOwnerUuid = getAccountOwnerUuid;
exports.createAccountSelectors = (0, reselect_1.createSelector)([
    function (_a) {
        var user = _a.user;
        return user.accessByUuid[user.duplicateUuid];
    },
    function (_a) {
        var user = _a.user;
        return user.byUuid[user.duplicateUuid];
    },
    exports.selectPermissions,
], function (access, user, _a) {
    var canSeeAllAccounts = _a.canSeeAllAccounts;
    return ({
        access: access,
        formDefaults: mapUserToUserRow(user, canSeeAllAccounts),
    });
});
var selectUserAvatarProps = function (_state, props) { return props; };
exports.userAvatarSelector = (0, reselect_1.createSelector)([
    exports.selectUserAccessTokenById,
    exports.selectUserAccessTokenByUuid,
    exports.selectUsers,
    selectUserAvatarProps,
], function (accessTokenById, accessTokenByUuid, users, props) {
    var _a;
    var userUuid = props.userUuid, accountUuid = props.accountUuid, accessTokenUuid = props.accessTokenUuid, accessTokenId = props.accessTokenId;
    var hasIdentifier = userUuid || accountUuid || accessTokenUuid || accessTokenId;
    if (hasIdentifier) {
        var richAccessToken = (accessTokenByUuid === null || accessTokenByUuid === void 0 ? void 0 : accessTokenByUuid[accessTokenUuid || '']) ||
            (accessTokenById === null || accessTokenById === void 0 ? void 0 : accessTokenById[accessTokenId || '']);
        var richAccessTokenUserRecord = (_a = richAccessToken === null || richAccessToken === void 0 ? void 0 : richAccessToken.richAccount) === null || _a === void 0 ? void 0 : _a.user;
        var userRecord = richAccessTokenUserRecord ||
            users.find(function (user) { return user.uuid === userUuid || user.accountUuid === accountUuid; });
        if (userRecord) {
            return {
                name: "".concat(userRecord.firstName || '').concat(userRecord.lastName ? " ".concat(userRecord.lastName) : '') || 'Unknown Name',
            };
        }
    }
    return {};
});
exports.selectIsOnboardingContractSigned = (0, reselect_1.createSelector)([exports.selectSignedOnboardingContractsTypes], function (signedOnboardingContractsTypes) {
    return ((0, difference_1.default)([
        finance_client_1.OnboardingContractType.TermsOfService,
        finance_client_1.OnboardingContractType.PrivacyPolicy,
    ], signedOnboardingContractsTypes).length === 0);
});
